// xzpre
const HOST = {
  origin: '',
  pplp: '//pplpsit.cnsuning.com',
  pplpsit: '//pplpsit.cnsuning.com', // 用于判断sit环境

  // 徐庄 sit
  pppassport: '//psptwebsit1.cnsuning.com',
  pppassportsend: '//psptwebsit1.cnsuning.com',

  snpassport: '//passportsit.cnsuning.com',

  // 徐庄 pre
  // pppassport: '//pplpsit.cnsuning.com/xzpassport',
  // snpassport: '//passportpre.cnsuning.com',

  paypassport: '//paypassport.suning.com',

  suning: '//www.suning.com',
  pptv: '//www.pptv.com',
  wechat: '//open.weixin.qq.com',

  siller: '//dtsit.cnsuning.com', // 风控拖动取值
  aq: '//aqpre.cnsuning.com', // 解除风控
  vcs: '//vcsprexg.cnsuning.com',
  reg: '//regprexg.cnsuning.com', // 一账通升级URL

  snreg: '//reg.suning.com', // 苏宁注册
  ppgateway: '//ppgatewaysit.cnsuning.com',

  ppsports: '//ppwebsit.cnsuning.com',
  isports: '//sacssit.cnsuning.com',

  mppsport: '//mspssit.suning.com',
  ppgw: '//ppgwsit.cnsuning.com',
  vippptv: '//api.vip.pptv.com',
  pgoods: '//pgoodsxgpre.cnsuning.com',
  pcoupon: '//pcouponxgpre.cnsuning.com',
  apipay: '//psvppaysit1.cnsuning.com',
  porder: '//porderxgpre.cnsuning.com',

  // 收银台 使用 prd 接口
  epg: '//epg.api.pptv.com',
  livecenter: '//livecenter.pptv.com/',
  ddp: '//api.ddp.vip.pptv.com',
  // 收银台 end
  ppwfs: '//ppwfspre.cnsuning.com',
};

const ENV = 'sit';

export {
  HOST,
  ENV,
};
